module.exports = __webpack_public_path__ + "assets/img/js.61403a81.png";